import { r as t } from "./register-BfgAj5eG.js";
import { B as g } from "./register-BfgAj5eG.js";
const r = {
  cta: "button--cta",
  primary: "button--primary",
  "primary-light": "button--primary-light",
  secondary: "button--secondary",
  "secondary-light": "button--secondary-light",
  ghost: "button--ghost",
  "ghost-light": "button--ghost-light",
  link: "button--link",
  "link-light": "button--link-light"
};
t();
export {
  g as Button,
  r as VARIANT
};
